var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.854 76.0549C149.574 65.9432 145.392 55.7958 143.08 51.0273C135.422 39.2628 130.09 36.2075 123.365 32.3538L123.233 32.278C112.759 26.276 88.1943 16.6954 76.8279 15.6683C62.6199 14.3844 52.3674 19.0262 44.9572 25.175C37.5469 31.3238 27.6579 41.7913 20.9246 67.9041C15.5379 88.7943 23.1895 100.24 30.1578 108.687L41.8666 122.046L56.4173 136.912C65.9939 136.863 88.9855 136.242 104.34 134.156C123.533 131.548 132.805 116.858 135.189 113.259C140.255 105.612 145.999 86.9569 147.854 76.0549Z",
    fill: "url(#paint0_linear_1772_9446)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.486 104.429L134.547 112.789L133.062 115.091L131.28 117.66L129.103 120.266L126.531 122.907C117.659 119.539 110.867 116.625 110.111 115.811C109.299 112.867 112.254 106.574 113.486 104.429Z",
    stroke: "black",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.818 63.0231C127.668 55.81 139.955 54.6382 144.415 54.9491C138.495 38.6035 125.37 32.6219 112.52 26.7659L112.241 26.6389C101.731 21.8485 81.5873 14.6399 69.5303 15.3969C55.0362 16.3068 44.159 23.9829 37.1726 32.4419C30.1863 40.9008 22.933 57.2496 20.9236 66.1611C18.5442 76.7138 15.0789 93.8553 27.3566 103.362C40.9425 113.883 60.9988 120.13 78.83 122.842C94.6026 125.241 102.466 109.967 105.803 103.484L105.804 103.482C109.14 97.0013 116.757 72.0395 122.818 63.0231Z",
    fill: "url(#paint1_linear_1772_9446)",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9734 78.1626C75.7212 82.3898 78.0982 88.6441 82.6648 90.4568C87.2314 92.2694 93.0737 88.3465 94.5105 84.7267C95.9473 81.1068 94.9159 75.0246 89.6241 72.924C83.9662 70.2989 79.4103 74.5427 77.9734 78.1626Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5203 60.9165C32.2681 65.1437 34.6451 71.3981 39.2116 73.2107C43.7782 75.0233 49.6206 71.1004 51.0574 67.4806C52.4942 63.8607 51.4628 57.7785 46.1709 55.678C40.513 53.0528 35.9571 57.2966 34.5203 60.9165Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.37788,
    cy: 2.96673,
    rx: 3.37788,
    ry: 2.96673,
    transform: "matrix(-0.929457 -0.368931 -0.368931 0.929457 91.0781 77.2578)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.37788,
    cy: 2.96673,
    rx: 3.37788,
    ry: 2.96673,
    transform: "matrix(-0.929457 -0.368931 -0.368931 0.929457 47.875 60.1094)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.675577,
    cy: 0.674257,
    rx: 0.675577,
    ry: 0.674257,
    transform: "matrix(-0.929457 -0.368931 -0.368931 0.929457 47.4961 65.4688)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.675577,
    cy: 0.674257,
    rx: 0.675577,
    ry: 0.674257,
    transform: "matrix(-0.929457 -0.368931 -0.368931 0.929457 90.6953 82.6172)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.7543,
    height: 4.31525,
    rx: 2.15762,
    transform: "matrix(-0.929457 -0.368931 -0.368931 0.929457 63 96)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6579 100.471C92.6901 96.4169 102.269 99.5665 106.354 101.764C102.043 111.183 99.4755 115.73 92.8243 119.998C87.5398 123.39 81.1008 123.597 75.073 121.972L80.4692 108.377C82.6408 102.906 85.2861 101.525 86.6579 100.471Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.606 66.7344C130.46 64.7931 138.344 63.77 142.536 63.4382L142.279 74.9854C139.598 74.3098 128.736 75.5961 121.337 81.7198L123.255 71.6407C123.587 71.0717 124.988 68.5154 127.606 66.7344Z",
    fill: "#CAA2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9968 128.616L125.398 123.379L123.799 124.715L122.016 126.13C119.785 127.657 116.363 130.02 111.683 131.579C107.938 132.827 105.072 133.47 98.4097 133.882L90.6544 134.755L73.119 128.318L53.573 121.249L36.3512 115.019L27.2866 104.782L26.7626 103.791C38.2833 112.412 63.8904 121.277 78.4984 124.18L98.9968 128.616Z",
    fill: "#7057F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5829 134.133L71.2323 130.025L60.6654 134.826L81.5829 134.133Z",
    fill: "#383740"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.623 107.787L130.531 114.102L127.736 117.48L113.45 111.964C113.12 110.843 113.955 108.657 114.623 107.787Z",
    fill: "#826CF7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1227 133.739L68.189 129.399L56.9021 134.785L79.1227 133.739Z",
    fill: "#634AE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4258 135.719L35.7444 115.587L40.2923 120.939L41.8632 122.745L42.9105 123.949L56.1447 137.674L65.1687 137.512L74.3279 137.01L91.4258 135.719Z",
    fill: "#7057F0",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3864 134.636L68.8779 129.671L57.9099 135.183L81.3864 134.636Z",
    fill: "#644AE7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_9446",
    x1: 144.44,
    y1: 57.0876,
    x2: 72.7007,
    y2: 143.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_9446",
    x1: 98.0641,
    y1: 20.8336,
    x2: 86.3465,
    y2: 178.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453744,
    stopColor: "#F3EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCA6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/RobotIcon.c4b47c8a1183279d1ad0146d8d21be73.svg";
export { ForwardRef as ReactComponent };